/**
 * @module OperationProgressService
 * @purpose API service for the one generic progress-poll endpoint (FR16a) --
 *   any long-running background operation started under the
 *   evidence-container-foundation PRP (staged verify, container inventory)
 *   publishes its progress under an `operationId`, read here.
 * @depends apiClient from ./api; evidence-containers types
 * @dependedOnBy Later hooks/components layers (Layers 7-8 of this feature).
 *
 * @rules
 * - Performance: intended for short-interval polling from a hook; no caching
 *   here -- callers own poll cadence.
 * - State: stateless service layer; all state managed in hooks.
 * - Errors: `ApiError` propagated to callers; a 404 means an unknown
 *   `operationId` OR one belonging to a different case (AC18 -- no existence
 *   oracle, byte-identical body either way).
 */

import { apiClient } from './api'
import type { OperationProgress } from '../types/evidence-containers'

/**
 * Poll a long-running operation's progress.
 *
 * `GET /api/cases/:id/operations/:operationId/progress`
 */
export async function getOperationProgress(
  caseId: string,
  operationId: string
): Promise<OperationProgress> {
  return apiClient.get<OperationProgress>(`/cases/${caseId}/operations/${operationId}/progress`)
}
